import { render, staticRenderFns } from "./Psychology.vue?vue&type=template&id=85ea7936&"
import script from "./Psychology.vue?vue&type=script&lang=js&"
export * from "./Psychology.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports